import { PrimaryInfo } from './../util';
import { GHRProvider } from "../../models/GHRProvider";

export const getSuggestion = (ghr: GHRProvider): PrimaryInfo => {
    return {
        name: ghr.name,
        id: ghr.id
    };
};
